var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYouTube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_638_538)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.9989 99.9978C77.6125 99.9978 99.9978 77.6125 99.9978 49.9989C99.9978 22.3853 77.6125 0 49.9989 0C22.3853 0 0 22.3853 0 49.9989C0 77.6125 22.3853 99.9978 49.9989 99.9978Z",
    fill: "#383838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2979 33.1495C86.7545 40.791 86.8553 48.6252 86.5685 56.3809C86.2368 60.2532 85.9813 64.1613 85.0693 67.9551C84.3119 70.2946 82.6469 72.4145 80.3657 73.4252C78.2256 74.5837 75.7404 74.6128 73.3785 74.8661C66.8934 75.3299 60.3925 75.6773 53.8872 75.5451C51.5477 75.5607 49.2082 75.5719 46.8665 75.5675C39.2564 75.554 31.6418 75.377 24.0699 74.6061C21.1724 74.3955 18.1853 73.2145 16.4463 70.8011C14.4587 68.2128 14.2682 64.8134 13.8514 61.703C13.3987 55.5316 13.0514 49.3221 13.5399 43.1417C13.7102 39.3904 13.9253 35.5966 14.9853 31.9731C15.9511 28.717 18.9696 26.2991 22.2704 25.7075C24.5718 25.3131 26.9113 25.2347 29.2306 24.9703C35.3461 24.5938 41.4704 24.4683 47.597 24.4369C51.653 24.4168 55.7068 24.4369 59.7629 24.4526C65.8671 24.7686 72.0116 24.7798 78.062 25.7411C81.6967 26.4537 84.6458 29.5148 85.3001 33.1495H85.2979ZM61.7998 50.0033C55.3797 46.3417 48.9864 42.6196 42.5685 38.9423C42.5774 46.317 42.5774 53.6896 42.5685 61.0599C48.9864 57.3871 55.3774 53.6649 61.7998 50.0033Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5684 38.9423C48.9863 42.6196 55.3773 46.3417 61.7997 50.0033C55.3796 53.6672 48.9863 57.3871 42.5684 61.0599C42.5773 53.6896 42.5773 46.3148 42.5684 38.9423Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_638_538"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouTube);
export default __webpack_public_path__ + "static/media/YouTube.72caa730826af03a3f7945c7d12dd660.svg";
export { ForwardRef as ReactComponent };